import React from 'react'
import PropTypes from 'prop-types'

import * as Component from './WordHints.styles'

import DOMPurify from 'dompurify'

const WordHints = ({ title, hint, ...rest }) => (
  <Component.Container { ...rest }>
    <Component.Title { ...rest }>
      {title}
      {hint && (
        <Component.WordHintsTooltip
          arrow='middle'
          infoIconId='info-icon'
          tooltipId='tooltip'
          dialogTitle={ title }>
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(hint) }} />
        </Component.WordHintsTooltip>
      )}
    </Component.Title>
  </Component.Container>
)

WordHints.propTypes = {
  /* word for rendering */
  title: PropTypes.string.isRequired,
  /* hint */
  hint: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

export default WordHints
